import _ from "lodash";
import moment from "moment";
import React, { useState } from "react";

import CardSecondary from "@/components/UI/Card/CardSecondary";
import DatePicker from "@/components/UI/DatePicker";
import images from "@/utils/images";
import { LAB_FINDING_QUESTIONS } from "@/constants/lab";

export const PrescribeLabFindings = (props) => {
  const { editable, editHandler, note } = props;

  let labFindings = note.content.lab_findings;
  let [showCalender, setShowCalendar] = useState(
    Object.keys(LAB_FINDING_QUESTIONS).reduce((acc, key) => {
      acc[key] = false;

      return acc;
    }, {}),
  );

  const handleCalendarClick = (key) => {
    if (!editable) {
      return;
    }

    let showCalendarClone = _.cloneDeep(showCalender);

    showCalendarClone[key] = !showCalendarClone[key];
    setShowCalendar(showCalendarClone);
  };

  const onDateChange = (date, eventType, key) => {
    if (eventType !== "monthChange") {
      handleCalendarClick(key);
    }

    const dateParts = date.split("-");
    let formattedDate = dateParts[1] + "/" + dateParts[2] + "/" + dateParts[0];

    handleEditCopyChange({ target: { value: formattedDate } }, key, "date");
  };

  const handleEditCopyChange = (e, index, key) => {
    if (!editable) {
      return;
    }

    let editCopyClone = _.cloneDeep(labFindings);

    editCopyClone[index][key] = e.target.value;

    if (editHandler) {
      editHandler("lab_findings", editCopyClone);
    }
  };

  let content = (
    <div>
      {Object.entries(labFindings)
        .sort((a, b) => (a[1].order && b[1].order ? a[1].order - b[1].order : 0))
        .map(([key, value]) => {
          return (
            <div className="m-2" key={key}>
              <div className="row m-1">
                <div className="mr-2 tw:font-bold">{value.label}</div>
                <input
                  className="fs-10 mr-1"
                  disabled={!editable ? true : null}
                  onClick={() => handleCalendarClick(key)}
                  placeholder="mm/dd/yyyy"
                  style={{ width: 64 }}
                  value={value.date}
                />

                {editable && (
                  <img
                    alt="calendar icon"
                    onClick={() => handleCalendarClick(key)}
                    src={images("./icons/calender-icon.svg")}
                    style={{ width: 15 }}
                  />
                )}

                {showCalender[key] && (
                  <div className="note-date-picker-wrapper">
                    <DatePicker
                      externalCtx={
                        value.date && value.date !== ""
                          ? moment(value.date, "MM/DD/YYYY")
                          : moment()
                      }
                      loadingSlots={false}
                      onDaySelect={(date, eventType) => onDateChange(date, eventType, key)}
                    />
                  </div>
                )}
              </div>

              <div className="w-100">
                <input
                  className="w-100"
                  disabled={!editable ? true : null}
                  onChange={(e) => handleEditCopyChange(e, key, "description")}
                  placeholder="Reviewed & Findings"
                  value={value.description}
                />
              </div>
            </div>
          );
        })}
    </div>
  );

  return (
    <>
      <CardSecondary className="px-2 py-3 m-3">
        <p className="tw:font-bold">Labs and findings</p>
        {content}
      </CardSecondary>
    </>
  );
};
